var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConsultingProp1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 53,
    viewBox: "0 0 71 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 37.84C16.3099 38.26 16.9099 38.35 17.3299 38.04L22.3299 34.36C22.7499 34.05 22.8399 33.45 22.5299 33.03C22.2199 32.61 21.6199 32.52 21.1999 32.83L16.1999 36.51C15.7799 36.82 15.6899 37.42 15.9999 37.84Z",
    fill: "url(#paint0_linear_793_83)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.31046 47.9196C2.62046 48.3396 3.22046 48.4296 3.64046 48.1196L8.90046 44.2496C9.32046 43.9396 9.41046 43.3396 9.10046 42.9196C8.79046 42.4996 8.19046 42.4096 7.77046 42.7196L2.51046 46.5896C2.09046 46.8996 2.00046 47.4996 2.31046 47.9196Z",
    fill: "url(#paint1_linear_793_83)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.78019 31.6893L8.83019 37.1893C9.14019 37.6093 9.74019 37.6993 10.1602 37.3893C10.5802 37.0793 10.6702 36.4793 10.3602 36.0593L6.31019 30.5593C6.00019 30.1393 5.40019 30.0493 4.98019 30.3593C4.56019 30.6693 4.47019 31.2693 4.78019 31.6893Z",
    fill: "url(#paint2_linear_793_83)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6698 45.1297L18.5398 50.3897C18.8498 50.8097 19.4498 50.8997 19.8698 50.5897C20.2898 50.2797 20.3798 49.6797 20.0698 49.2597L16.1998 43.9997C15.8898 43.5797 15.2898 43.4897 14.8698 43.7997C14.4498 44.1097 14.3598 44.7097 14.6698 45.1297Z",
    fill: "url(#paint3_linear_793_83)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.190186 39.2894C0.330186 39.4894 0.550186 39.6294 0.810186 39.6694L7.26019 40.6495C7.78019 40.7294 8.26019 40.3694 8.34019 39.8494C8.42019 39.3294 8.06019 38.8494 7.54019 38.7694L1.09019 37.7894C0.570186 37.7094 0.0901857 38.0694 0.0101857 38.5894C-0.0298143 38.8494 0.0401857 39.0994 0.180186 39.2994L0.190186 39.2894Z",
    fill: "url(#paint4_linear_793_83)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16.99 41.85C17.13 42.05 17.35 42.19 17.61 42.23L23.75 43.16C24.27 43.24 24.75 42.88 24.83 42.36C24.91 41.84 24.55 41.36 24.03 41.28L17.89 40.35C17.37 40.27 16.89 40.63 16.81 41.15C16.77 41.41 16.84 41.66 16.98 41.86L16.99 41.85Z",
    fill: "url(#paint5_linear_793_83)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.90991 52.51C10.0499 52.71 10.2699 52.85 10.5299 52.89C11.0499 52.97 11.5299 52.61 11.6099 52.09L12.5899 45.64C12.6699 45.12 12.3099 44.64 11.7899 44.56C11.2699 44.48 10.7899 44.84 10.7099 45.36L9.72991 51.81C9.68991 52.07 9.75991 52.32 9.89991 52.52L9.90991 52.51Z",
    fill: "url(#paint6_linear_793_83)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4207 36.0197C12.5607 36.2197 12.7807 36.3597 13.0407 36.3997C13.5607 36.4797 14.0407 36.1197 14.1207 35.5997L15.1007 29.1497C15.1807 28.6297 14.8207 28.1497 14.3007 28.0697C13.7807 27.9897 13.3007 28.3497 13.2207 28.8697L12.2407 35.3197C12.2007 35.5797 12.2707 35.8297 12.4107 36.0297L12.4207 36.0197Z",
    fill: "url(#paint7_linear_793_83)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3999 4.74001C58.3199 4.86001 58.2699 5.00001 58.2499 5.15001C58.2099 5.48001 58.3499 5.81001 58.6199 6.01001L67.3799 12.53C67.6499 12.73 67.9999 12.77 68.3099 12.64C68.6199 12.51 68.8299 12.22 68.8699 11.89L70.1299 1.05001C70.1699 0.72001 70.0299 0.39001 69.7599 0.19001C69.4899 -0.00998974 69.1399 -0.0499897 68.8299 0.0800103L58.8099 4.41001C58.6399 4.48001 58.4999 4.60001 58.3999 4.75001V4.74001ZM67.1899 10.06L61.0299 5.47001L68.0799 2.42001L67.1899 10.05V10.06Z",
    fill: "url(#paint8_linear_793_83)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_793_83",
    x1: 58.3999,
    y1: 146.78,
    x2: -9.99008,
    y2: -47.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_793_83",
    x1: 43.2005,
    y1: 152.12,
    x2: -25.1895,
    y2: -42.4804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_793_83",
    x1: 48.4702,
    y1: 150.269,
    x2: -19.9198,
    y2: -44.3307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_793_83",
    x1: 53.0298,
    y1: 148.67,
    x2: -15.3602,
    y2: -45.9303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_793_83",
    x1: 43.7802,
    y1: 151.919,
    x2: -24.6098,
    y2: -42.6806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_793_83",
    x1: 57.81,
    y1: 146.99,
    x2: -10.5801,
    y2: -47.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_793_83",
    x1: 47.0299,
    y1: 150.78,
    x2: -21.36,
    y2: -43.83,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_793_83",
    x1: 54.4307,
    y1: 148.18,
    x2: -13.9693,
    y2: -46.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_793_83",
    x1: 104.84,
    y1: 118.76,
    x2: 36.4499,
    y2: -75.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDB79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFD379"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FFBF79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#FF9D79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#FF5479"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#F74E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E34091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#C129AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#940AD7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8500E5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsultingProp1);
export default __webpack_public_path__ + "static/media/ConsultingProp_1.c32ec0ad1a42a8b593bef623878c9c85.svg";
export { ForwardRef as ReactComponent };